namespace Gamification.Gamification {
    export class ProdottiBadgeEditorColumns {
        static columnsKey = 'Gamification.ProdottiBadgeEditor';
    }
}
